const links = [
  {
    href: "/quiz",
    name: "Quizler",
  },
  {
    href: "/akademi",
    name: "Akademi",
  },
  {
    href: "/bilim-kurulu",
    name: "Bilim Kurulu",
  },
  {
    href: "/hakkimizda",
    name: "Hakkımızda",
  },
  {
    href: "/iletisim",
    name: "İletişim",
  },
];

type SubLink = {
  id: number | string;
  title: string;
  description?: string;
  icon?: string;
  href: string;
};

type NavLink =
  | {
      id: number | string;
      title: string;
      href: string;
      subLinks?: never;
    }
  | {
      id: number | string;
      title: string;
      href?: never;
      subLinks: SubLink[];
    };
export const tools: SubLink[] = [
  {
    description:
      "Vücudunuzun birçok değişimi aynı anda yaşadığı bu dönemde daha sağlıklı bir gebelik süreci geçirebilmek için size",
    href: "/hesaplamalar",
    icon: "calculator",
    id: 21,
    title: "Hesaplamalar",
  },
  {
    description:
      "Hamilelik yolculuğunun sonunda dünyaya bir mucize getireceksiniz. O, hayata gözlerini açtığı ilk andan itibaren size ihtiyaç duyacak. Onun ihtiyaçları kadar gelişimini doğru şekilde takip edebilmeniz de önemli…",
    href: "/ekitap",
    icon: "calculator",
    id: 22,
    title: "e-Kitaplar",
  },
  {
    description:
      "Hayatınızın en güzel serüvenine hazır mısınız? “Hamilelik, eğer inanmıyorsanız, hayatınızda mucizelere inanmaya",
    href: "/bebek-isimleri",
    icon: "calculator",
    id: 23,
    title: "Bebek İsimleri",
  },
];
export const articles: SubLink[] = [
  {
    description:
      "Vücudunuzun birçok değişimi aynı anda yaşadığı bu dönemde daha sağlıklı bir gebelik süreci geçirebilmek için size",
    href: "/gebelik-planlama",
    icon: "",
    id: 11,
    title: "Gebelik Planlama",
  },
  {
    description:
      "Hayatınızın en güzel serüvenine hazır mısınız? “Hamilelik, eğer inanmıyorsanız, hayatınızda mucizelere inanmaya",
    href: "/gebelik",
    icon: "embryo",
    id: 12,
    title: "Gebelik",
  },
  {
    description:
      "Bebeveyn Akademi, bebeğiniz büyürken ihtiyacınız olan bilgi ve uygulamaları size sunan bir ebeveyn platformudur. Bilgiyi sevgiyle harmanlayarak “Bugün bebeğim için ne yapabilirim?” dediğiniz her an sizin ve bebeğinizin yanınızda.",
    href: "/bebeveyn-akademi",
    icon: "academy",
    id: 13,
    title: "Bebeveynlik",
  },
  {
    description:
      "Hamilelik yolculuğunun sonunda dünyaya bir mucize getireceksiniz. O, hayata gözlerini açtığı ilk andan itibaren size ihtiyaç duyacak. Onun ihtiyaçları kadar gelişimini doğru şekilde takip edebilmeniz de önemli…",
    href: "/baby",
    icon: "baby",
    id: 14,
    title: "Bebek",
  },
  {
    description:
      "Her çocuk farklı yaş dönemlerine, birbirinden farklı tepkiler gösterir. Büyük bir değişim olacağı düşünülmese de, birkaç ay bile değişikliklere gebedir. Bu kategori altında çocuklara dair merak ettiklerinizi bulabilirsiniz.",
    href: "/child",
    icon: "child",
    id: 15,
    title: "Çocuk",
  },
  {
    description:
      "İster çocuk sahibi olmuş olun, ister anneliğe ilk adımınız olsun her iki durumda da bilmeniz gereken o kadar çok şey var ki. Doğumdan önce ve sonra doğru bilgilere ulaşabilmek için bu kategori altındaki tüm bilgileri iyice okumanızı tavsiye ederiz…",
    href: "/dogum-ve-sonrasi",
    icon: "parent",
    id: 16,
    title: "Doğum ve Sonrası",
  },
];
const navLinks: NavLink[] = [
  {
    href: "/forum",
    id: 4,
    title: "Forum",
  },
  {
    href: "/danismanliklar",
    id: 5,
    title: "Danışmanlıklar",
  },
] as const;

export { links as HeaderLinks, navLinks as navigationLinks };
